import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Radio } from "@circle-react-uikit/Radio";

export interface RadioOptionProps {
  dataTestId?: string;
  id: string;
  isSelected: boolean;
  label: string | React.ReactNode;
  value: string;
}
export const RadioOption = ({
  id,
  value,
  isSelected,
  label,
  dataTestId,
}: RadioOptionProps) => (
  <label
    className={classNames("mb-0 p-4 first:rounded-t-xl last:rounded-b-xl", {
      "bg-secondary": isSelected,
    })}
    htmlFor={id}
    data-testid={dataTestId}
  >
    <Radio
      id={id}
      value={value}
      labelWrapperClassName="w-full"
      labelClassName="flex flex-col gap-y-1 w-full"
      label={label}
      checked={isSelected}
      name="paywall_price_id"
    />
  </label>
);
